// 6.9.2.5 (Task 18, E-57 ; fix round 1) : copie EXACTE, octet pour octet, de
// `docs/nf525/documentation-utilisateur-conservation.md` — la documentation
// UTILISATEUR (exploitant) de l'obligation de conservation sur support externe
// sécurisé. Module séparé (et non une constante locale de `FiscalArchives.tsx`)
// pour que `documentation-conservation.test.ts` puisse l'importer sans rendre le
// composant, et la comparer au fichier source (même garde-fou que
// `apps/engine/libs/fiscal-export/src/documentation.spec.ts` pour les trois
// copies de la documentation technique de l'archive).
export const DOCUMENTATION_CONSERVATION_MD = `# Conservation de vos archives fiscales — ce qui vous incombe

Ce document s'adresse à l'exploitant : la personne qui exploite une ou plusieurs
caisses Tickeat, pas à un développeur. Il répond à une seule question : **que
dois-je faire de mes archives fiscales, et pourquoi**. Il est référencé depuis
la carte « Vos archives fiscales » du dashboard (page Conformité).

## 1. Ce que la loi vous demande

La réglementation fiscale vous impose de conserver vos archives fiscales
**pendant six années ou exercices, plus l'année ou l'exercice en cours**, et
de les conserver **sur un support physique externe sécurisé** — distinct de
la caisse et du serveur qui les a produites.

Cette obligation vous incombe à vous, exploitant : ni Tickeat, ni aucun
logiciel, ne peut s'y substituer. Le rôle de Tickeat s'arrête à vous fournir
une archive complète, signée et vérifiable ; le rôle de la conserver hors
ligne, sur un support que vous maîtrisez, reste le vôtre.

## 2. Ce que Tickeat fait pour vous

- À la clôture de chaque exercice, l'archive de la caisse est **constituée,
  signée et déposée automatiquement** — vous n'avez rien à déclencher.
- Chaque archive reste **consultable et téléchargeable à tout moment** depuis
  la page Conformité du dashboard, avec le détail de sa dernière vérification.
- Aucune archive n'est **jamais purgée** par Tickeat : la caisse et l'engine
  n'ont aucune fonction de suppression des données de vente et d'encaissement.

Ce que fait Tickeat garantit que l'archive existe, qu'elle est intègre et
qu'elle reste accessible tant que vous restez client. Cela ne remplace pas
l'obligation du 1 : une archive qui ne vit que chez Tickeat n'est pas, à elle
seule, conservée sur un support externe sécurisé au sens de la réglementation.

## 3. Ce qui vous reste à faire

- **Télécharger chaque archive d'exercice dès qu'elle est disponible**, depuis
  la page Conformité de la caisse concernée.
- La **déposer sur un support physique externe sécurisé** (disque externe,
  coffre numérique, tout support que vous maîtrisez et qui n'est ni la caisse
  ni un service dont vous perdriez l'accès en cas de résiliation).
- En garder une **seconde copie hors site**, à distance du premier support :
  un incendie ou un vol ne doit jamais coûter les deux exemplaires à la fois.
- **Vérifier la lisibilité du support au moins une fois par an**, pas
  seulement au moment du dépôt.

## 4. Comment vérifier une archive sans Tickeat

Chaque archive est prévue pour rester vérifiable même si Tickeat disparaissait
ou si vous n'aviez plus accès au dashboard :

- l'outil en ligne de commande \`nf525-verify\` rejoue le contenu du ZIP et
  contrôle chaque chaîne de signatures ;
- un \`DOCUMENTATION.md\` est **embarqué dans chaque ZIP** : il explique le
  format de l'archive et la méthode de vérification sans dépendre d'un lien
  externe qui pourrait disparaître ;
- la **clé publique de l'éditeur**, et son historique complet en cas de
  rotation, sont publiés sur la page Conformité — c'est avec cette clé, et
  elle seule, qu'une signature d'archive se vérifie.

## 5. En cas de contrôle

L'administration peut demander, au titre de vos obligations fiscales :

- l'**archive de l'exercice concerné**, telle que téléchargée depuis la page
  Conformité — c'est le document à présenter en premier ;
- la **preuve de sa vérification** (résultat de \`nf525-verify\`, ou le rapport
  affiché par le bouton « Vérifier » sur la page Conformité) ;
- le **journal des événements techniques (JET)** de la caisse concernée,
  inclus dans l'archive elle-même.

Tenez vos archives téléchargées et vos copies externes à jour : c'est ce que
vous présentez, pas un accès au dashboard qui pourrait ne plus être valable
le jour du contrôle. Pour toute question sur une archive ou sa vérification,
contactez le support Tickeat (support@tickeat.io).
`;
